<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!--desktop-->
    <div class="card" *ngIf="_utilsService.isDesktop">
      <div class="card-title w-100 p-2 m-0">
        <div class="row">
          <div class="col-md-8 col-12 d-flex">
            <div>
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="search()" />
            </div>
            <div class="ml-1 w-fit">
              <select id="status" class="form-control pr-4" [(ngModel)]="filter_type" (ngModelChange)="search()">
                <option [value]="-1">{{ "INSERT.SELECT_CONTRACTS" | translate }}</option>
                <option *ngFor="let type of type_contract_list" [value]="type.id">{{ type.name }}</option>
              </select>
            </div>
            <div class="mx-1 d-flex align-items-center">
              <label for="start" class="mr-025 mb-0">{{ "FROM" | translate }}</label>
              <input type="date" id="start" [(ngModel)]="day_start" (ngModelChange)="search()" class="form-control" />
            </div>
            <div class="d-flex align-items-center">
              <label for="end" class="mr-025 mb-0">{{ "TO" | translate }}</label>
              <input type="date" id="end" [(ngModel)]="day_end" (ngModelChange)="search()" class="form-control" />
            </div>
          </div>
          <div class="col-md-4 col-12 text-right">
            <div class="w-fit d-inline-block mr-2">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
            <button class="btn btn-outline-primary" has_capability="export_employees_contracts_list" (click)="exportContracts()">{{ "EXPORT_EXCEL" | translate }}</button>
          </div>
        </div>
        <div class="row mt-05">
          <div class="col-12 font-small-3 font-weight-normal">{{ 'LAST_UPDATE' | translate }}: {{ _utilsService.themeConfiguration.last_costs_monthly_update | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="50" [scrollbarH]="true" [rowHeight]="70" [footerHeight]="50"
                       [sorts]="[{ prop: 'lastname', dir: 'asc' }]"
                       [rows]="filtered_contract_list" [limit]="tableLimit" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }">
          <ngx-datatable-column [name]="'LASTNAME_AND_FIRSTNAME' | translate" prop="complete_name" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center employee-name" [ngClass]="row.class_name" [ngbTooltip]="row.tooltip ? (row.tooltip | translate) : null">
                <a routerLink="/dashboard/user/edit/{{ row.user_hash }}" [queryParams]="{ section: 'contract' }" target="_blank">{{ row.lastname }} {{ row.firstname }}</a>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CONTRACT_AND_LEVEL' | translate" prop="contract_name" [sortable]="false" width="100">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.contract_name }} {{ row.level ? "-" : null }} {{ row.level }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'START_DATE' | translate" prop="start_date" [sortable]="true" width="80">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.start_date | date: 'dd/MM/yyyy' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'END_DATE' | translate" prop="end_date" [sortable]="true" width="80">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.end_date ? (row.end_date | date: 'dd/MM/yyyy') : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'SALARY_YEARLY_GROSS' | translate" prop="salary_yearly_gross" [sortable]="true" width="90">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.salary_yearly_gross | currency: 'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TICKET' | translate" prop="ticket_value" [sortable]="true" width="90">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.ticket_value | currency: 'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'REFUND' | translate" prop="bonus" [sortable]="true" width="80">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.bonus | currency: 'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'COST_DAILY' | translate" prop="total_daily" [sortable]="true" width="100">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.total_daily | currency: 'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TFR_AMOUNT' | translate" prop="tfr_amount" [sortable]="true" width="100">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.tfr_amount | currency: 'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>

    <!--mobile-->
    <div class="card" *ngIf="!_utilsService.isDesktop">
      <div class="card-title w-100 p-2 m-0">
        <div class="row">
          <div class="col-12">
            <input type="search" id="keyword_mobile" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="search()" />
          </div>
          <div class="col-12 my-1">
            <select id="status_mobile" class="form-control pr-4" [(ngModel)]="filter_type" (ngModelChange)="search()">
              <option [value]="-1">{{ "INSERT.SELECT_CONTRACTS" | translate }}</option>
              <option *ngFor="let type of type_contract_list" [value]="type.id">{{ type.name }}</option>
            </select>
          </div>
          <div class="d-flex align-items-center col-12">
            <label for="start_mobile" class="mr-075 mb-0">{{ "FROM" | translate }}</label>
            <input id="start_mobile" type="date" [(ngModel)]="day_start" (ngModelChange)="search()" class="form-control" />
          </div>
          <div class="d-flex align-items-center col-12 mt-1">
            <label for="end_mobile" class="mr-075 mb-0">{{ "TO" | translate }}</label>
            <input id="end_mobile" type="date" [(ngModel)]="day_end" (ngModelChange)="search()" class="form-control" />
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="50"
          [rowHeight]="200"
          [footerHeight]="50"
          [rows]="filtered_contract_list"
          [limit]="tableLimit"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
        >
          <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="complete_name" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row" [ngClass.sm]="'list-item-mobile'">
                <div class="col 12">
                  <div class="d-flex align-items-center employee-name">
                    <a routerLink="/dashboard/user/edit/{{ row.user_hash }}" target="_blank">{{ row.complete_name }} </a>
                  </div>
                </div>
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <div>
                      <span>{{ row.contract_name }}</span><span *ngIf="row.level"> - {{ row.level }}</span>
                    </div>
                    <div>
                      <span>{{ "FROM" | translate }}: {{ row.start_date | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div>
                      <span>{{ "TO" | translate }}: {{ row.end_date ? (row.end_date | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div>
                      <span>{{ "SALARY_YEARLY_GROSS" | translate }}: {{ row.salary_yearly_gross | currency: 'EUR' }}</span>
                    </div>
                    <div>
                      <span>{{ "TICKET" | translate }}: {{ row.ticket_value | currency: 'EUR' }}</span>
                    </div>
                    <div>
                      <span>{{ "BONUS" | translate }}: {{ row.bonus | currency: 'EUR' }}</span>
                    </div>
                    <div>
                      <span>{{ "TFR_AMOUNT" | translate }}: {{ row.tfr_amount | currency: 'EUR' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
